module.exports = __webpack_public_path__ + "robotomono-regular-webfont-6c1ce30b90ee993b22618ec489585594.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto-mono/robotomono-regular-webfont.woff2
// module id = 869
// module chunks = 86